import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as HeaderIcon } from '../../../assets/icons/svg/icon-new-lili-logo.svg';
import { ReactComponent as RatesIcon } from '../../../assets/icons/svg/large-icons/ic-large-fdic.svg';
import Heading from '../../../generic-components/Heading';
import Button from '../../../generic-components/Button';
import { VIEWS_MAP } from '../../../router/constants';
import { useGetStartData } from '../hooks/useGetStartData';
import Spinner, { SpinnerColor } from '../../../generic-components/Spinner';
import { useStore } from '../../../store';
import { identifyMixPanelUser, trackMixPanel } from '../../../services/mixpanel.service';

export const GetStarted = () => {
  const resetOnboardingData = useStore((state) => state.resetOnboardingData);
  const obData = useStore((state) => state.obData);
  const setOnboardingData = useStore((state) => state.setObData);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const {
    data: accountantResponse,
    isRefetching,
    isLoading,
  } = useGetStartData({
    customerId: searchParams.get('customerId') || '',
    authorizedUserId: searchParams.get('authId') || '',
    handleError: (errCode) => {
      navigate(
        `/${VIEWS_MAP.ACCOUNTANT_ONBOARDING.START}/${VIEWS_MAP.ACCOUNTANT_ONBOARDING.OB_FAILED.BASE}/${errCode}`,
      );
    },
  });

  useEffect(() => {
    identifyMixPanelUser(searchParams.get('customerId') || '').then(() => {
      trackMixPanel('Page view', { pageName: 'Accountant 1st invite' });
    });
    resetOnboardingData();
    setOnboardingData({
      ...obData,
      authorizedUserId: searchParams.get('authId') || '',
      customerId: searchParams.get('customerId') || '',
    });
  }, []);

  return isLoading || isRefetching || !accountantResponse ? (
    <Spinner spinnerColor={SpinnerColor.Blue} height='2rem' width='2rem' />
  ) : (
    <div className='flex flex-col items-center justify-center grow h-full bg-bw00'>
      <div className='flex flex-col items-center justify-center grow max-w-[450px]'>
        <HeaderIcon className='mb-[24px]' />
        <Heading
          title={t('ACCOUNTANT_OB.GET_STARTED.HEADING')}
          className='font-metricRSemibold text-bw08 text-[32px]'
        />
        <Heading
          title={t('ACCOUNTANT_OB.GET_STARTED.SUB_HEADER')}
          className='font-metricR text-center text-bw08 text-[20px] mb-[52px]'
        />
        <Heading
          title={t('ACCOUNTANT_OB.GET_STARTED.CONTENT')
            .replace('[customer name]', accountantResponse?.data?.customerFirstName)
            .replace('[business name]', accountantResponse?.data?.customerBusinessName || '')}
          className='font-metricR text-center text-bw07 text-[16px] break-words mb-[52px]'
        />
        <Button
          onClick={() =>
            navigate(`/${VIEWS_MAP.ACCOUNTANT_ONBOARDING.START}/${VIEWS_MAP.ACCOUNTANT_ONBOARDING.PERSONAL_DETAILS}`, {
              replace: true,
            })}
          className='w-full bg-action03 hover:bg-action04 font-metricRMedium text-bw00 py-[17px] rounded-[4px]'
          title={t('ACCOUNTANT_OB.GET_STARTED.CTA')}
          id='getStarted'
        />
      </div>
      <div className='w-full flex items-center justify-center pb-[40px]'>
        <RatesIcon />
      </div>
    </div>
  );
};
